import {Component, ElementRef, Injector, OnInit, ViewChild} from '@angular/core';
import {PomodoroRepository} from '../Models/PomodoroRepository';
import {Sound} from '../Models/Sound.model';
import {Setting} from '../Models/setting.model';
import {SettingService} from '../services/setting.service';
import {SoundApi} from '../Models/sound-api.model';
import {SoundService} from '../services/sound.service';
import {CategoryService} from '../services/category.service';
import {SnackBarService} from '../services/snack-bar.service';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog} from '@angular/material/dialog';
import {AlertDialogComponent} from '../alert-dialog/alert-dialog.component';
import {ChartService} from '../services/chart.service';
import {Label, SingleDataSet} from 'ng2-charts';
import {ChartType} from 'chart.js';
import {UserService} from '../services/user.service';
import {TaskService} from '../services/task.service';
import {FormControl} from '@angular/forms';
import {Router} from '@angular/router';

export interface DialogData {
  animal: 'panda' | 'unicorn' | 'lion';
}

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit {
  @ViewChild('inp',{static: false}) inp: ElementRef;
  public proVersion = 'true';
  public helperVar = false;
  public isPremium;
  public error: any;
  public myControl = new FormControl();
  public tab = 'tab3';
  public doughnutChartLabels: Label[] = [];
  public doughnutChartData: SingleDataSet = [];
  public doughnutChartType: ChartType = 'doughnut';
  public userPomoCount: number;
  public breakTest: any;
  public pieChartColors = [
    {
      backgroundColor: ['#DC143C', '#DC1483', '#B414DC', '#3314DC', '#14C0DC', '#14DC9B', '#ABDC14', '#DCA814', '#DC7014', '#353535'],
    },
  ];
  public pomodoroRepository: PomodoroRepository;
  public setting: Setting = new Setting();
  public settingId;
  public soundApi: SoundApi[];
  public pomodoroAud = new Audio();
  public breakAud = new Audio();
  public firstSpinner = false;
  public secondSpinner = false;
  public initSound: SoundApi = new SoundApi(99, 'تست 99', 'assets/sounds/countdown_10sec_effects.mp3');
  public userIsLoggedIn;
  public showChart: any;
  public permissionStatus;
  public notificationAllow;
  public controllerOne;
  public controllerTwo;
  public controllerThree;
  public controllerFour;
  public editMode = false;
  public myTest: any;

  constructor(private settingService: SettingService,
              public injector: Injector,
              private soundService: SoundService,
              private categoryService: CategoryService,
              private snackBarService: SnackBarService,
              public translateService: TranslateService,
              public dialog: MatDialog,
              private chartService: ChartService,
              public taskService: TaskService,
              private router: Router,
              private userService: UserService) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  ngOnInit(): void {
    if (Notification.permission === 'granted'){
      this.notificationAllow = 'granted';
    } else if (Notification.permission === 'default'){
      this.notificationAllow = 'default';
    } else if (Notification.permission === 'denied'){
      this.notificationAllow = 'denied';
    }
    this.isPremium = localStorage.getItem('isPremium');
    this.proVersion = this.isPremium;
    const token = localStorage.getItem('token');
    if (token !== null) {
      this.getSettingInformation();
      this.userIsLoggedIn = true;
      this.taskService.getAllDoneTaskInfo().subscribe(
        (data) => {
          this.userPomoCount = data.sum_count;
        }
      );
      this.getSounds();
      this.getWeekDoughtChart();
    } else {
      this.userIsLoggedIn = false;
    }
    if (this.userIsLoggedIn === false && this.proVersion === null) {
      this.helperVar = false;
    } else if (this.userIsLoggedIn === true && this.proVersion === 'false') {
      this.helperVar = false;
    } else {
      this.helperVar = true;
    }
    this.setting.pomodoro_time_length = this.pomodoroRepository.defaultMeasure;
    this.setting.be_in_pomodoro_ranking = this.pomodoroRepository.beInPomodoroRanking;
    this.setting.send_rest_notification = this.pomodoroRepository.sendRestNotification;
    this.setting.send_pomodoro_notification = this.pomodoroRepository.sendPomodoroNotification;
    this.setting.start_next_rest_automatic = this.pomodoroRepository.autoNextBreak;
    this.setting.start_next_pomodoro_automatic = this.pomodoroRepository.autoNextPomodoro;
    this.setting.short_rest_time = this.pomodoroRepository.shortBreak;
    this.setting.long_rest_time = this.pomodoroRepository.longBreak;
    this.setting.pomodoro_count_after_long_rest = this.pomodoroRepository.defaultCount;
    this.setting.dark_mode = this.pomodoroRepository.darkMode;
    // if (localStorage.getItem('status') === 'start' && localStorage.getItem('isBreak') === '1'){
    //
    // }
    // this.pomodoroRepository.getTokenDoneTime();
    this.notifyMe();
  }
  onBlur(event): any {
    this.inp.nativeElement.focus();
    this.inp.nativeElement.autofocus = true;
  }
  getDuration(timeLength): any {
    this.pomodoroRepository.defaultMeasure = timeLength;
    this.pomodoroRepository.save();
  }

  // tslint:disable-next-line:typedef
  getShortBreak(shortBreak) {
    this.pomodoroRepository.shortBreak = shortBreak;
    this.pomodoroRepository.save();
  }

  // tslint:disable-next-line:typedef
  getLongBreak(longBreak) {
    this.pomodoroRepository.longBreak = longBreak;
    this.pomodoroRepository.save();
  }

  // tslint:disable-next-line:typedef
  getPomoCount(defaultCount) {
    this.pomodoroRepository.defaultCount = defaultCount;
    this.pomodoroRepository.save();
  }

  // tslint:disable-next-line:typedef
  getAutoNextPomodoro(autoNextPomodoro) {
    this.pomodoroRepository.autoNextPomodoro = autoNextPomodoro;
    this.pomodoroRepository.save();
  }

  // tslint:disable-next-line:typedef
  getAutoNextRest(autoNextRest) {
    this.pomodoroRepository.autoNextBreak = autoNextRest;
    this.pomodoroRepository.save();
  }

  // tslint:disable-next-line:typedef
  getPomodoroNotification(sendPomodoroNotification) {
    this.pomodoroRepository.sendPomodoroNotification = sendPomodoroNotification;
    this.pomodoroRepository.save();
  }

  // tslint:disable-next-line:typedef
  getRestNotification(sendRestNotification) {
    this.pomodoroRepository.sendRestNotification = sendRestNotification;
    this.pomodoroRepository.save();
  }

  // tslint:disable-next-line:typedef
  getRanking(PomodoroRanking) {
    this.pomodoroRepository.beInPomodoroRanking = PomodoroRanking;
    this.pomodoroRepository.save();
  }

  deleteFromCategories(myControl): any {
    this.pomodoroRepository.getCategory = myControl;
    this.dialog.open(AlertDialogComponent);
  }

  displayFn(s: Sound): string {
    return s.name;
  }

  showBool(): any {
    // this.pomodoroRepository.save();
    this.pomodoroRepository.saveToLocalStorage();
  }

  getSettingInformation(): any {
    this.settingService.getSettingInformation().subscribe(
      (data) => {
        this.setting = data.data;
        localStorage.setItem('pomoAudio', JSON.stringify(this.setting.pomodoro_sound));
        localStorage.setItem('breakAudio', JSON.stringify(this.setting.rest_sound));
        localStorage.setItem('settingId', data.data.id);
      },
      (error) => {
        if (error.status === 500 && error.error === 'Unauthenticated.') {
          this.pomodoroRepository.prevLang = localStorage.getItem('trans');
          localStorage.clear();
          localStorage.setItem('trans', this.pomodoroRepository.prevLang);
          this.userService.logOut();
          this.pomodoroRepository.userIsLoggedIn = false;
          this.router.navigateByUrl('/login').then();
        }
      }
    );
  }

  updateSetting(): any {
    this.firstSpinner = true;
    this.setting.pomodoro_sound_id = this.pomodoroRepository.pomodoroSoundId;
    this.setting.rest_sound_id = this.pomodoroRepository.restSoundId;
    this.settingService.updateSetting(this.setting).subscribe(
      (data) => {
        this.setting = data.data;
        this.pomodoroRepository.darkMode = data.data.dark_mode;
        localStorage.setItem('darkMode', this.pomodoroRepository.darkMode ? '1' : '0');
        this.firstSpinner = false;
        if (localStorage.getItem('trans') === 'fa') {
          this.snackBarService.showSnackBar('تغییرات با موفقیت اعمال شد.', 'green-snackbar');
        } else if (localStorage.getItem('trans') === 'en') {
          this.snackBarService.showSnackBar('Changes have been saved successfully.', 'ltr-green-snackbar');
        }
      }, (err) => {
        this.error = err.error;
        if (this.pomodoroRepository.ltrDirection === true) {
          this.snackBarService.showSnackBar(this.error.pomodoro_time_length[0], 'ltr-snackbar');
        } else if (this.pomodoroRepository.ltrDirection === false) {
          this.snackBarService.showSnackBar(this.error.pomodoro_time_length[0], 'red-snackbar');
        }
        this.firstSpinner = false;
      }
    );
  }

  errorForInput(): any {
    this.snackBarService.showSnackBar('نمی توانید کمتر از یک وارد کنید', 'red-snackbar');
  }

  increaseTimeLength(): any {
    this.setting.pomodoro_time_length++;
    this.pomodoroRepository.defaultMeasure = this.setting.pomodoro_time_length;
    this.pomodoroRepository.saveToLocalStorage();
    if (this.pomodoroRepository.defaultMeasure === 1) {
      this.controllerOne = true;
    }
    if (this.pomodoroRepository.defaultMeasure > 1) {
      this.controllerOne = false;
    }
  }

  decreaseTimeLength(): any {
    if (this.setting.pomodoro_time_length === 1) {
      this.controllerOne = true;
    }
    this.pomodoroRepository.saveToLocalStorage();
    if (this.setting.pomodoro_time_length > 1) {
      this.controllerOne = false;
      this.setting.pomodoro_time_length--;
      this.pomodoroRepository.defaultMeasure = this.setting.pomodoro_time_length;
    }
  }

  increasePomoCount(): any {
    this.setting.pomodoro_count_after_long_rest++;
    this.pomodoroRepository.defaultCount = this.setting.pomodoro_count_after_long_rest;
    this.pomodoroRepository.saveToLocalStorage();
    if (this.pomodoroRepository.defaultCount < 2) {
      this.controllerTwo = true;
    }
    if (this.pomodoroRepository.defaultCount > 1) {
      this.controllerTwo = false;
    }
  }

  decreasePomoCount(): any {
    // this.setting.pomodoro_count_after_long_rest--;
    // this.pomodoroRepository.defaultCount = this.setting.pomodoro_count_after_long_rest;
    // this.pomodoroRepository.saveToLocalStorage();
    // if (this.pomodoroRepository.defaultCount < 2){
    //   this.controllerTwo = true;
    // }
    // if (this.pomodoroRepository.defaultCount > 1){
    //   this.controllerTwo = false;
    // }
    if (this.setting.pomodoro_count_after_long_rest === 1) {
      this.controllerTwo = true;
    }
    this.pomodoroRepository.saveToLocalStorage();
    if (this.setting.pomodoro_count_after_long_rest > 1) {
      this.controllerTwo = false;
      this.setting.pomodoro_count_after_long_rest--;
      this.pomodoroRepository.defaultCount = this.setting.pomodoro_count_after_long_rest;
    }
  }

  increaseShortBreak(): any {
    this.setting.short_rest_time++;
    this.pomodoroRepository.shortBreak = this.setting.short_rest_time;
    this.pomodoroRepository.saveToLocalStorage();
    if (this.pomodoroRepository.shortBreak < 2) {
      this.controllerThree = true;
    }
    if (this.pomodoroRepository.shortBreak > 1) {
      this.controllerThree = false;
    }
  }

  decreaseShortBreak(): any {
    if (this.setting.short_rest_time === 1) {
      this.controllerTwo = true;
    }
    this.pomodoroRepository.saveToLocalStorage();
    if (this.setting.short_rest_time > 1) {
      this.controllerTwo = false;
      this.setting.short_rest_time--;
      this.pomodoroRepository.shortBreak = this.setting.short_rest_time;
    }
  }

  increaseLongBreak(): any {
    this.setting.long_rest_time++;
    this.pomodoroRepository.longBreak = this.setting.long_rest_time;
    this.pomodoroRepository.saveToLocalStorage();
    if (this.pomodoroRepository.longBreak < 2) {
      this.controllerFour = true;
    }
    if (this.pomodoroRepository.longBreak > 1) {
      this.controllerFour = false;
    }
  }

  decreaseLongBreak(): any {
    if (this.setting.long_rest_time === 1) {
      this.controllerTwo = true;
    }
    this.pomodoroRepository.saveToLocalStorage();
    if (this.setting.long_rest_time > 1) {
      this.controllerTwo = false;
      this.setting.long_rest_time--;
      this.pomodoroRepository.longBreak = this.setting.long_rest_time;
    }
  }

  notifyMe(): any {
    if (!('Notification' in window)) {
      alert('This browser does not support desktop notification');
    } else if (Notification.permission === 'granted') {
      this.permissionStatus = true;
    } else if (Notification.permission !== 'denied') {
      this.permissionStatus = false;
      // Notification.requestPermission().then((permission) => {
      //   if (permission === 'granted') {
      //     alert('Im Granted');
      //   }
      // });
    }
  }

  permissionNotification(): any {
    Notification.requestPermission().then();
  }

  sendSuccessMessage(): any {
    if (localStorage.getItem('trans') === 'fa') {
      this.snackBarService.showSnackBar('تغییرات با موفقیت اعمال شد.', 'green-snackbar');
    } else if (localStorage.getItem('trans') === 'en') {
      this.snackBarService.showSnackBar('Changes have been saved successfully.', 'green-snackbar');
    }
  }

  turnEditMode(): any {
    this.editMode = !this.editMode;
    this.categoryService.syncCategory(this.pomodoroRepository.categories).subscribe();
  }

  syncCat(): any {
    this.categoryService.syncCategory(this.pomodoroRepository.categories).subscribe();
    this.editMode = false;
  }
  onClick(check): any {
    if (check === 1) {
      this.tab = 'tab1';
    } else if (check === 2) {
      this.tab = 'tab2';
    } else if (check === 3) {
      this.tab = 'tab3';
    }
  }

  getWeekDoughtChart(): any {
    // if (check === 1){
    //   this.tab = 'tab1';
    // }
    this.chartService.getWeekPieCategoryChart().subscribe(
      (data) => {
        this.doughnutChartData = data.map(d => d.time);
        this.doughnutChartLabels = data.map(d => d.title);
      }
    );
  }

  getMonthDoughtChart(): any {
    // if (check === 2){
    //   this.tab = 'tab2';
    // }
    this.chartService.getMonthPieCategoryChart().subscribe(
      (data) => {
        this.doughnutChartData = data.map(d => d.time);
        this.doughnutChartLabels = data.map(d => d.title);
      }
    );
  }

  getYearDoughtChart(): any {
    // if (check === 3){
    //   this.tab = 'tab3';
    // }
    this.chartService.getYearPieCategoryChart().subscribe(
      (data) => {
        this.doughnutChartData = data.map(d => d.time);
        this.doughnutChartLabels = data.map(d => d.title);
      }
    );
  }

  chartStake(): any {
    const token = localStorage.getItem('token');
    if (token !== null && this.userPomoCount > 0) {
      this.showChart = true;
    } else {
      this.showChart = false;
    }
  }

  getSounds(): any {
    this.soundService.getListOfSound().subscribe(
      (data) => {
        this.pomodoroRepository.pomoSounds = data.data;
        localStorage.setItem('apiPomoSound', JSON.stringify(this.pomodoroRepository.pomoSounds));
        this.pomodoroRepository.breakSounds = data.data;
        localStorage.setItem('apiBreakSound', JSON.stringify(this.pomodoroRepository.breakSounds));
        this.settingService.getSettingInformation().subscribe(
          (res) => {
            if (res.data.pomodoro_sound === null) {
              this.pomodoroRepository.pomodoroSoundId = 1;
            } else {
              this.pomodoroRepository.pomodoroSoundId = res.data.pomodoro_sound.id;
              this.setting.pomodoro_sound_id = res.data.pomodoro_sound.id;
            }
            if (res.data.rest_sound === null) {
              this.pomodoroRepository.restSoundId = 2;
            } else {
              this.pomodoroRepository.restSoundId = res.data.rest_sound.id;
              this.setting.rest_sound_id = res.data.rest_sound.id;
            }
          }
        );
      });
  }

  darkModeSwitch(darkMode): any {
    this.updateSetting();
  }
  sendModel(category: any): any{
    this.pomodoroRepository.arrangeAddingTasks = category.target.value;
    localStorage.setItem('arrangeAddingTasks', this.pomodoroRepository.arrangeAddingTasks);
  }

  defaultMode(): any{
    this.pomodoroRepository.defaultMeasure = 25;
    this.pomodoroRepository.shortBreak = 5;
    this.pomodoroRepository.longBreak = 20;
    this.pomodoroRepository.defaultCount = 4;
    this.setting.pomodoro_time_length = 25;
    this.setting.pomodoro_count_after_long_rest = 4;
    this.setting.short_rest_time = 5;
    this.setting.long_rest_time = 20;
    this.pomodoroRepository.saveToLocalStorage();
    this.updateSetting();
  }
}
